import frame0 from "./0.png";
import frame1 from "./1.png";
import frame10 from "./10.png";
import frame11 from "./11.png";
import frame12 from "./12.png";
import frame13 from "./13.png";
import frame14 from "./14.png";
import frame15 from "./15.png";
import frame16 from "./16.png";
import frame17 from "./17.png";
import frame18 from "./18.png";
import frame19 from "./19.png";
import frame2 from "./2.png";
import frame20 from "./20.png";
import frame21 from "./21.png";
import frame22 from "./22.png";
import frame23 from "./23.png";
import frame24 from "./24.png";
import frame25 from "./25.png";
import frame26 from "./26.png";
import frame27 from "./27.png";
import frame28 from "./28.png";
import frame29 from "./29.png";
import frame3 from "./3.png";
import frame30 from "./30.png";
import frame31 from "./31.png";
import frame32 from "./32.png";
import frame4 from "./4.png";
import frame5 from "./5.png";
import frame6 from "./6.png";
import frame7 from "./7.png";
import frame8 from "./8.png";
import frame9 from "./9.png";

export const what_we_gonna_do: string[] = [
  frame0,
  frame1,
  frame2,
  frame3,
  frame4,
  frame5,
  frame6,
  frame7,
  frame8,
  frame9,
  frame10,
  frame11,
  frame12,
  frame13,
  frame14,
  frame15,
  frame16,
  frame17,
  frame18,
  frame19,
  frame20,
  frame21,
  frame22,
  frame23,
  frame24,
  frame25,
  frame26,
  frame27,
  frame28,
  frame29,
  frame30,
  frame31,
  frame32,
];
